import service from "@/store/services/subtipos-service";

const state = {
  list: {},
  subtipo: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, subtipo) => {
    state.subtipo = subtipo;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((role) => {
      commit("SET_RESOURCE", role);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((subtipo) => {
      commit("SET_RESOURCE", subtipo);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((subtipo) => {
      commit("SET_RESOURCE", subtipo);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  subtipo: (state) => state.subtipo,
  dropdown: (state) => {
    return state.list.map((subtipo) => ({
      id: subtipo.id,
      nombre: subtipo.nombre,
    }));
  },
};

const subtipos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default subtipos;
